export default __webpack_public_path__ + "static/media/EGFR.d5cc7b0f.png";